import {store} from '../store/store.js';
import axios from "axios";
import swal from 'sweetalert2'
import moment from 'moment';
import Vue from "vue";
import {version} from "../../package.json";

export default {

  getMyStringBack: function (str) {
    return ("string to return " + str);
  },

  getFileTypeIcon(mimeType) {
    let iconClass = "";

    // console.log("getFileTypeIcon for mimeType: ", mimeType);
    if (mimeType === null || mimeType === '') {
      return ''
    }

    switch (this.getFileTypeFromMimeType(mimeType)) {
      case 'pdf':
        iconClass = "fa fa-file-pdf";
        break;
      case 'word':
        iconClass = "fa fa-file-word";
        break;

      case 'excel':
        iconClass = "fa fa-file-excel";
        break;

      case 'powerpoint':
        iconClass = "fa fa-file-powerpoint";
        break;

      case 'text/csv':
        iconClass = "fa fa-file-csv";
        break;

      case 'image':
        iconClass = "fas fa-file-image";
        break;

      case 'video':
        iconClass = "fas fa-file-video";
        break;

      case 'audio':
        iconClass = "fas fa-file-audio";
        break;

      case 'text':
        iconClass = "fas fa-file-alt";
        break;

      case 'archive':
        iconClass = "far fa-file-archive";
        break;

      case 'html':
        iconClass = "fas fa-code";
        break;

      case 'unknown':
        iconClass = "fas fa-file-alt";
        break;

      default:
        iconClass = "fas fa-file-alt";
        break;
    }
    return iconClass
  },

  getFileTypeFromMimeType(mimeType) {
    let fileType = "";

    // console.log("fileType from mimeType: ", mimeType);
    if (mimeType === null || mimeType === '') {
      return ''
    }

    switch (mimeType) {
      case 'application/pdf':
        fileType = "pdf";
        break;
      case 'application/msword':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
        fileType = "word";
        break;

      case 'application/vnd.ms-excel':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
        fileType = "excel";
        break;

      case 'application/vnd.ms-powerpoint':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      case 'application/vnd.openxmlformats-officedocument.presentationml.template':
      case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
        fileType = "powerpoint";
        break;

      case 'text/csv':
        fileType = "csv";
        break;

      case 'image/bmp':
      case 'image/cis-cod':
      case 'image/gif':
      case 'image/ief':
      case 'image/jpeg':
      case 'image/png':
      case 'image/pipeg':
      case 'image/svg+xml':
      case 'image/tiff':
      case 'image/x-cmu-raster':
      case 'image/x-cmx':
      case 'image/x-icon':
      case 'image/x-portable-anymap':
      case 'image/x-portable-bitmap':
      case 'image/x-portable-graymap':
      case 'image	image/x-portable-pixmap':
      case 'image/x-rgb':
      case 'image/x-xbitmap':
      case 'image/x-xwindowdump':
        fileType = "image";
        break;

      case 'video/x-flv':
      case 'video/mp4':
      case 'application/x-mpegURL':
      case 'video/MP2T':
      case 'video/3gpp':
      case 'video/quicktime':
      case 'video/x-msvideo':
      case 'video/x-ms-wmv':
        fileType = "video";
        break;

      case 'audio/basic':
      case 'audio/L24':
      case 'audio/mid':
      case 'audio/mpeg':
      case 'audio	audio/mp4':
      case 'audio/x-aiff':
      case 'audio/x-mpegurl':
      case 'audio/vnd.rn-realaudio':
      case 'audio/ogg':
      case 'audio/vorbis':
      case 'audio/vnd.wav':
        fileType = "audio";
        break;

      case 'application/vnd.oasis.opendocument.text':
      case 'application/vnd.oasis.opendocument.text-template':
      case 'application/vnd.oasis.opendocument.text-web':
      case 'application/vnd.oasis.opendocument.text-master':
        fileType = "text";
        break;

      case 'application/zip':
      case 'application/rar':
      case 'application/tar':
      case 'application/arj':
        fileType = "archive";
        break;

      case 'text/html':
        fileType = "html";
        break;

      default:
        fileType = "unknown";
        break
    }
    return fileType
  },

  getReadableDocumentMetadataCodeListValues(allMetadataOptions, nodeData) {
    const _this = this;

    //console.log("---->", nodeData);

    _.each(allMetadataOptions, function (val, key) {
      let property = val.property;

      if (nodeData.properties[property]) {

        console.log("property", property);

        if (property === "EH:rok_hrambe") {
          nodeData.properties[property] = _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}) ? _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}).explanation : nodeData.properties[property];
        } else if (property === "EH:izvorna_oblika") {
          nodeData.properties[property] = _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}) ? _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}).mimetype : nodeData.properties[property];
        } else {
          nodeData.properties[property] = _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}) ? _.find(allMetadataOptions[key].body, {id: nodeData.properties[property]}).description : nodeData.properties[property];
        }

      }
    });

    return nodeData
  },

  getReadableCodeListValueFromProperty(allMetadataOptions, propertyName, propertyValue) {

    let readableValue = propertyValue;
    propertyValue = String(propertyValue);

    // console.log("allMetadataOptions", allMetadataOptions);
    // console.log("propertyName", propertyName);
    // console.log("propertyValue", propertyValue);
    // console.log("searching");

    _.map(allMetadataOptions, function (val, key) {
      let property = val.property;

      if (property === propertyName) {

        // console.log("FOUND!!!!");
        // console.log("propertyValue", propertyValue);
        // console.log("propertyName", propertyName);
        // console.log(allMetadataOptions[key]);

        let metadataOptionsMappedToString = _.map(allMetadataOptions[key].body, (x) => {x.id = String(x.id); return x;});
        // console.log("metadataOptionsString", metadataOptionsMappedToString);

        if (propertyName === 'EH:rok_hrambe') {
          readableValue = _.find(metadataOptionsMappedToString, {id: propertyValue}) ? _.find(metadataOptionsMappedToString, {id: propertyValue}).explanation : propertyValue;
        } else if (propertyName === "EH:izvorna_oblika") {
          readableValue = _.find(metadataOptionsMappedToString, {id: propertyValue}) ? _.find(metadataOptionsMappedToString, {id: propertyValue}).mimetype : propertyValue;
        } else {
          readableValue = _.find(metadataOptionsMappedToString, {id: propertyValue}) ? _.find(metadataOptionsMappedToString, {id: propertyValue}).description : propertyValue;
        }

        // console.log("READABLE", readableValue);
        return;
      }
    });

    return readableValue;
  },

  checkForPermission(permission) {
    let rolesPermissions = store.getters.getPermissions;

    let hasPermission = false;

    _.map(rolesPermissions, function (val) {
      if (_.filter(val.permissions, {id: permission}).length > 0) {
        hasPermission = true;
      }
    });

    //return true
    return hasPermission
  },

  checkUserRole(role) {
    let permissions = store.getters.getPermissions;
    let isRoleCorrect = false;
    _.map(permissions, function (val) {
      if (val.role === role) {
        isRoleCorrect = true;
      }
    });
    return isRoleCorrect;
  },

  formatFieldNameForSort(fieldName) {
    if (fieldName === 'createdAt') {
      return 'cm:created';

    }
    if (fieldName === 'modifiedAt') {
      return 'cm:modified';
    } else {
      return fieldName;
    }
  },

  getQueryVariable(query, variable) {
    console.log("query", query);
    console.log("variable", variable);

    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      let pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) == variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    console.log('Query variable %s not found', variable);
  },

  generateReport(data, options) {

    const locale = Vue.prototype.i18n._vm.locale;
    const messages = Vue.prototype.i18n._vm.$root.messages[locale];

    const _this = this;
    console.log("generateReport ->", data);

    if (options && options.dontWaitForResponse) {
      data.dontWaitForResponse = true;
    } else {
      data.dontWaitForResponse = false;
    }

    if (typeof data.description === 'undefined') {

      swal.fire({
        title: messages.text.globalFunctions.generateReportSwal.title,
        icon: 'info',
        type: 'info',
        html: '<div class="form-group"><label class="col-md-12" for="title">' + messages.text.globalFunctions.generateReportSwal.enterReportDescription + '</label><textarea class="form-control" id=\'descriptionTextarea\'></textarea></div>',
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: messages.text.globalFunctions.generateReportSwal.confirmButtonText,
        cancelButtonText: messages.text.globals.close,
      })
        .then((result) => {
          if (result.dismiss === 'cancel') {

          } else {
            if (document.getElementById('descriptionTextarea').value !== '') {
              data.description = document.getElementById('descriptionTextarea').value;
            }
            _this.submitReportGenerationData(data, options);
          }
        });
    } else {
      _this.submitReportGenerationData(data, options);
    }


  },

  async submitReportGenerationData(data, options) {

    const locale = Vue.prototype.i18n._vm.locale;
    const messages = Vue.prototype.i18n._vm.$root.messages[locale];

    let nodeId = null;
    let title = null;
    let mimetype = null;
    const _this = this;

    // globally handle special case for role "ARHIV_RS"
    if (data.query && data.query.aftsQuery && !Vue.prototype.$globalFunctions.checkForPermission('DOST_DOK_IN_META') && Vue.prototype.$globalFunctions.checkForPermission('DOST_DOK_ARHIV')) {
      data.query.aftsQuery += ' AND EH:status_gradiva:3';
    }

    axios.post(config.reports + 'generate', data)
      .then((res) => {
        console.log("res", res);
        nodeId = res.data.resultNodeId;
        title = res.data.resultTitle;
        mimetype = res.data.resultMimetype;

        if (res.data.status === 0) {
          // report ready "instantaneously"

          swal.fire({
            title: messages.text.globalFunctions.reportGenerationSuccessSwal.title,
            icon: 'success',
            type: 'success',
            html: messages.text.globalFunctions.reportGenerationSuccessSwal.prompt,
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: messages.text.globalFunctions.reportGenerationSuccessSwal.reportDownload,
            cancelButtonText: messages.text.globals.close,
          })
            .then((result) => {
              if (result.value === true) {
                _this.downloadFile(nodeId, title, mimetype);
              }
            });

        } else if (res.data.status === 1) {
          // large dataset

          swal.fire({
            title: messages.text.globalFunctions.highQuantityOfSelectedDataDetectedSwal.title,
            icon: 'warning',
            type: 'warning',
            html: messages.text.globalFunctions.highQuantityOfSelectedDataDetectedSwal.prompt,
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: messages.text.globalFunctions.highQuantityOfSelectedDataDetectedSwal.confirmButtonText,
            cancelButtonText: messages.text.globals.close,
          })
            .then((result) => {
              if (result.value === true) {
                _this.generateReport(data, {'dontWaitForResponse': true});
              }
            });


        } else if (res.data.status === 2) {
          // it will take longer time to create report


            swal.fire({
              title: messages.text.globalFunctions.reportCreationWillTakeALongTimeSwal.title,
              icon: 'info',
              type: 'info',
              html: messages.text.globalFunctions.reportCreationWillTakeALongTimeSwal.prompt,
              showCloseButton: false,
              showCancelButton: false,
            });


        } else if (res.data.status === 3) {
          // error

          swal.fire({
            title: messages.text.globalFunctions.reportGenerationErrorSwal.title,
            icon: 'error',
            type: 'error',
            html: messages.text.globalFunctions.reportGenerationErrorSwal.prompt,
            showCloseButton: false,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: messages.text.globalFunctions.reportGenerationErrorSwal.confirmButtonText,
            cancelButtonText: messages.text.globals.close,
          })
            .then((result) => {
              if (result.value === true) {
                _this.downloadFile(nodeId, title, mimetype);
              }
            });
        } else if (res.data.status === 4) {

          swal.fire({
            title: messages.text.globalFunctions.noResultsToShowInReport.title,
            icon: 'info',
            type: 'info',
            html: messages.text.globalFunctions.noResultsToShowInReport.prompt,
            showCloseButton: false,
            showCancelButton: false,
          });

        }
      })
      .catch((error) => {
        console.error(error);
      });
  },

  downloadFile(nodeId, filename, mimetype) {
    console.log("downloadFile(" + nodeId + ", " + filename + ", " + mimetype + ")");
    let p1 = store.dispatch("downloadAttachment", {nodeId: nodeId, filename: filename, mimetype: mimetype});
    Promise.all([p1]).then((values) => {
      console.log("p1", p1);
      console.log("values", values);
    });
  },

  downloadXmlFile(data, fileName) {
    const blob = new Blob([data], {
      type: "text/xml; charset=UTF-8",
      encoding: "UTF-8"
    });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.setAttribute("download", fileName + ".xml");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },

  blobToFile(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  },

  parseDate(dateString, format) {
    console.log("dateString", dateString);
    return moment(dateString, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]').toDate();
  },
  formatDate(dateObj, format) {
    console.log(dateObj, format);
    return moment(dateObj, format).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    //return moment(dateObj, format);
  },

  getListColumns(listType) {
    let columns = [];

    const locale = Vue.prototype.i18n._vm.locale;
    const messages = Vue.prototype.i18n._vm.$root.messages[locale];

    if (listType === 'oiiu') {
      columns = messages.text.globalFunctions.oiiuColumns;
    } else if (listType === 'searchResults') {
      columns = messages.text.globalFunctions.searchResultsColumns;
    } else if (listType === 'izrocenoGradivo') {
      columns = messages.text.globalFunctions.izrocenoGradivoColumns;
    }

    return columns;
    // return _.sortBy(
    //     columns,
    //     [
    //         function(o) {
    //             return o.label;
    //         }
    //     ]
    // );

  },

  getAppVersionData(section) {

    if (version.indexOf('-') > -1) {
      if (section === 'environment') {
        let versionEnv = version.split('-')[1];
        return versionEnv;
      } else if (section === 'number') {
        let versionNum = version.split('-')[0];
        return versionNum;
      } else {
        return version;
      }
    } else {
      return
    }
  },

  checkIfRoleIsBlockedInProductionEnv() {
    let _this = this;
    let roleIsBlocked = false;
    let restrictedRoles = ["ALFRESCO_ADMIN", "POVEZAN_SISTEM", "EVIP"]; // TODO: add other roles!!!

    _.each(restrictedRoles, function (val) {
      if (_this.checkUserRole(val)) {
        roleIsBlocked = true;
      }
    });

    return roleIsBlocked;
  },

  // catch user roles that in PROD env should not browse GUI!
  checkIfRouteIsBlockedInProductionEnv(route) {
    // console.log("condition1", (route && route.name === 'Unauthorized'));
    // console.log("condition2", (route && route.name === 'Dashboard' && route.query.logout && route.query.logout === 'true'));
    // console.log("condition3", (this.getAppVersionData('environment') !== 'PROD'));
    // console.log("condition4", (!this.checkIfRoleIsBlockedInProductionEnv()));

    if (route && route.name === 'Dashboard' && route.query.logout && route.query.logout === 'true') {
      return false
    }

    if ((route && route.name === 'Unauthorized') || (this.getAppVersionData('environment') !== 'PROD') || (!this.checkIfRoleIsBlockedInProductionEnv())) {
      return false
    } else {
      return true
    }
  },

  reformatSortArray(sortArray) {
    let formattedSortArray = sortArray;
    console.log("formattedSortArray ----->", formattedSortArray);
    let opravilnaStevilkaZadeveFieldIdx = _.findIndex(formattedSortArray, {field: 'EH:opravilna_stevilka_zadeve'});

    if(opravilnaStevilkaZadeveFieldIdx < 0) {
      return formattedSortArray
    }

    formattedSortArray[opravilnaStevilkaZadeveFieldIdx] = {
      ascending:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].ascending,
      field:"EH:opravilna_stevilka_zadeve_vpisnik",
      type:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].type
    }

    formattedSortArray.push({
      ascending:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].ascending,
      field:"EH:opravilna_stevilka_zadeve_roman",
      type:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].type
    });

    formattedSortArray.push({
      ascending:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].ascending,
      field:"EH:opravilna_stevilka_zadeve_year",
      type:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].type
    });

    formattedSortArray.push({
      ascending:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].ascending,
      field:"EH:opravilna_stevilka_zadeve_num",
      type:formattedSortArray[opravilnaStevilkaZadeveFieldIdx].type
    });

    return formattedSortArray;
  }


}



// WEBPACK FOOTER //
// ./src/helpers/globalFunctions.js